<template>
  <div class="m-5">
    <FontAwesomeIcon
      :icon="['far', 'times-circle']"
      size="2x"
      class="absolute cursor-pointer text-secondary top-4 right-0 mr-3.5"
      @click="$modal.hide('MyClientAppointmentModal')"
    />
    <div class="h-full">
      <div class="my-5">
        <span v-if="reschedule">Rescheduling appointment</span>
        <span v-else>Appointment</span> with
        <span
          class="text-secondary-shade-2 cursor-pointer"
          @click="goToClient"
          >{{ name }}</span
        >
        on
        {{ time }}
      </div>
      <div v-if="!reschedule">
        <div class="text-3xl mb-2">
          {{ title }}
        </div>
        <div class="mb-24 overflow-y-auto" style="max-height: 78vh;">
          {{ description }}
        </div>
        <div class="absolute p-5 bottom-0 right-0 left-0 flex justify-center">
          <Button class="mr-1" @click="cancelEvent">Cancel</Button>
          <Button class="ml-1" @click="reschedule = true">Reschedule</Button>
        </div>
      </div>
      <div v-else>
        <div class="mb-24" style="height: 100px; max-height: 78vh;">
          <vc-date-picker
            v-model="date"
            mode="dateTime"
            style="position: fixed; z-index: 100;"
          >
            <template v-slot="{ inputValue, inputEvents }">
              <input
                class="px-2 py-1 border rounded focus:outline-none focus:border-blue-300"
                :value="inputValue"
                v-on="inputEvents"
              />
            </template>
          </vc-date-picker>
        </div>
        <div class="absolute p-5 bottom-0 right-0 left-0 flex justify-center">
          <Button class="ml-1" @click="rescheduleAppointment">
            Set New Date
          </Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import MyClientProfileModal from "@/pages/MyClients/components/MyClientProfileModal";

export default {
  name: "MyClientAppointmentModal",
  components: {},
  props: {
    appointment: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    name() {
      const { name, surname } = this.appointment.client;

      return `${name} ${surname}`;
    },
    time() {
      const calendarFormat = moment.unix(this.appointment.time).calendar(null, {
        sameDay: "[Today] - h:mma",
        nextDay: "[Tomorrow] - h:mma",
        nextWeek: "ddd - h:mma"
      });

      return calendarFormat;
    },
    title() {
      return this.appointment.title;
    },
    description() {
      return this.appointment.description;
    }
  },
  data() {
    return {
      reschedule: false,
      date: null
    };
  },
  methods: {
    goToClient() {
      this.$modal.show(
        MyClientProfileModal,
        {
          client: this.appointment.client
        },
        {
          name: "MyClientProfileModal",
          classes:
            "MyClientProfileModal rounded-xl rounded-r-none overscroll-contain",
          transition: "vm-transition--side-card",
          height: "100%",
          maxWidth: 600,
          shiftX: 1.0,
          scrollable: true,
          adaptive: true
        }
      );
    },
    rescheduleAppointment() {
      if (
        confirm(
          "Are you sure you want to change the appointment date? This will send a notification to your client and the event will be rescheduled as soon as the client approves!"
        )
      ) {
        this.$notify({
          type: "success",
          group: "foo",
          text: "Request sent!"
        });
        this.$modal.hide("MyClientAppointmentModal");
      }
    },
    cancelEvent() {
      if (
        confirm(
          "Are you sure you want to delete this event? This will send a notification to your client and the event will be cancelled immediately!"
        )
      ) {
        this.$notify({
          type: "success",
          group: "foo",
          text: "Appointment Cancelled!"
        });
        this.$modal.hide("MyClientAppointmentModal");
      }
    }
  },
  created() {}
};
</script>

<style></style>
